"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CertificateProgramValues;
(function (CertificateProgramValues) {
    CertificateProgramValues["ONLY_CERTIFICATE_PROGRAM"] = "Only Certificate Program";
})(CertificateProgramValues = exports.CertificateProgramValues || (exports.CertificateProgramValues = {}));
//# sourceMappingURL=AggregationPages.js.map